module.exports = __webpack_public_path__ + "static/media/cancel.bd0fd134.svg";